"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnchainRewardSlotHolderToJSON = exports.BurnchainRewardSlotHolderFromJSONTyped = exports.BurnchainRewardSlotHolderFromJSON = void 0;
function BurnchainRewardSlotHolderFromJSON(json) {
    return BurnchainRewardSlotHolderFromJSONTyped(json, false);
}
exports.BurnchainRewardSlotHolderFromJSON = BurnchainRewardSlotHolderFromJSON;
function BurnchainRewardSlotHolderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canonical': json['canonical'],
        'burn_block_hash': json['burn_block_hash'],
        'burn_block_height': json['burn_block_height'],
        'address': json['address'],
        'slot_index': json['slot_index'],
    };
}
exports.BurnchainRewardSlotHolderFromJSONTyped = BurnchainRewardSlotHolderFromJSONTyped;
function BurnchainRewardSlotHolderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'canonical': value.canonical,
        'burn_block_hash': value.burn_block_hash,
        'burn_block_height': value.burn_block_height,
        'address': value.address,
        'slot_index': value.slot_index,
    };
}
exports.BurnchainRewardSlotHolderToJSON = BurnchainRewardSlotHolderToJSON;
//# sourceMappingURL=BurnchainRewardSlotHolder.js.map